import React from "react";
import "../../Styles/certified/visailabs.css";

export default function Visailabs() {
	return (
		<>
			<div className="visailabs-certified-details-section">
				<div className="visailabs-certified-details-title">
					OUTSTANDING WORKPLACES CERTIFIED COMPANIES
				</div>
				<div className="visailabs-certified-details-container">
					{/* Left: Badge and Company Info side by side */}
					<div className="visailabs-certified-details-left">
						<img
							src="/Certified_Ribbon/Feb2026Feb2027.png"
							alt="Outstanding Workplaces Certified"
							className="visailabs-certified-badge"
						/>
						<div className="visailabs-certified-company-names">
							<a href="https://visailabs.com" target="_blank" rel="noopener noreferrer">
								<img src="/assets/visailabs/Visai-Labs-Dimensioner.jpg" alt="VisAI Labs Logo" className="visailabs-certified-company-logo" />
							</a>
							<h1 className="visailabs-certified-full-name">
								VisAI Labs Private Limited
							</h1>
						</div>
					</div>
					{/* Right: Company Image */}
					<div className="visailabs-certified-details-right">
						<img
							src="/assets/visailabs/office.jpeg"
							alt="VisAI Labs Office"
							className="visailabs-certified-company-image"
						/>
					</div>
				</div>
				{/* Description section below */}
				<div className="visailabs-certified-description">
					<h2>
						Why VisAI Labs Private Limited is an Outstanding Workplaces
					</h2>
					<p>
						• VisAI is an entity mainly focusing on products with Vision engineering and Artificial Intelligence. It is the Place, where complex AI tech gets built into products. <br />
                        • It is another Brainchild of e-con Systems and is a separate entity focusing on products with Vision engineering and Artificial Intelligence. <br />
                        • Incubated in 2018, the company began operations in 2024 and is now ready to expand and grow further. <br />
                        • We’ve been building cutting-edge computer vision products for the last 5+ years and shipped across the globe. <br />
                        • Since we are not just another AI company, we understand hands-on tech and what it takes from an engineer to build our products. <br />
                        • We are proud to say every complete product engineer at VisAI Labs who has spent time with us is capable of taking a whiteboard concept of a senior stakeholder to the product. So, we carefully handpick candidates whom we find, can grow into those roles. <br />
                        • Building products are fulfilling for any engineer but very few get a chance to build full computer vision products as there are very few companies who provide that opportunity and it’s not for the feeble heart as every day is a new challenge at VisAI Labs. We quench your thirst for computer vision engineering.
					</p>
				</div>
				{/* Info Cards Section */}
				<div className="visailabs-certified-info-cards">
					<div className="visailabs-certified-info-card">
						<div className="visailabs-certified-info-title">COMPANY SIZE</div>
						<div className="visailabs-certified-info-value">83 Employees</div>
					</div>
					<div className="visailabs-certified-info-card">
						<div className="visailabs-certified-info-title">INDUSTRY</div>
						<div className="visailabs-certified-info-value">Information Technology</div>
					</div>
					<div className="visailabs-certified-info-card">
						<div className="visailabs-certified-info-title">CONNECT</div>
						<div className="visailabs-certified-info-icons">
							<span className="visailabs-certified-icon-round">
								<a href="https://visailabs.com" target="_blank" rel="noopener noreferrer">
									<img src="/assets/website.png" alt="Website" />
								</a>
							</span>
							<span className="visailabs-certified-icon-round">
								<a href="https://www.linkedin.com/company/visailabs" target="_blank" rel="noopener noreferrer">
									<img src="/assets/linkedin.png" alt="LinkedIn" />
								</a>
							</span>
							<span className="visailabs-certified-icon-round">
								<a href="https://www.youtube.com/channel/UCEhSbUinD5jU5l0z_K0Hc7w" target="_blank" rel="noopener noreferrer">
									<img src="/assets/youtube.png" alt="YouTube" />
								</a>
							</span>
							{/* <span className="visailabs-certified-icon-round">
								<a href="https://www.instagram.com/visailabs" target="_blank" rel="noopener noreferrer">
									<img src="/assets/instagram.png" alt="Instagram" />
								</a>
							</span> */}
						</div>
					</div>
					<div className="visailabs-certified-info-card">
						<div className="visailabs-certified-info-title">LOCATION (HQ)</div>
						<div className="visailabs-certified-info-value">Chennai</div>
					</div>
				</div>
				{/* Recognitions Section */}
				<div className="visailabs-certified-recognition-section">
					<h2 className="visailabs-certified-recognition-title">
						Recognitions awarded by Outstanding Workplaces
					</h2>
					<div className="visailabs-certified-recognition-badge">
						<img
							src="/Certified_Ribbon/Feb2026Feb2027.png"
							alt="Outstanding Workplaces Certified"
							className="visailabs-certified-recognition-image"
						/>
					</div>
					<div className="visailabs-certified-recognition-label">
						Outstanding Workplaces - Certified
					</div>
				</div>
				{/* Life at VisAI Labs Section */}
				<div className="visailabs-certified-life-section">
					<h2 className="visailabs-certified-life-title">
						Life at VisAI Labs Private Limited
					</h2>
					<div className="visailabs-certified-life-gallery">
						<div className="visailabs-certified-life-col">
							<img src="/assets/visailabs/life1.jpeg" alt="Office 1" className="visailabs-certified-life-img" />
							<img src="/assets/visailabs/life2.jpeg" alt="Team 1" className="visailabs-certified-life-img" />
						</div>
						<div className="visailabs-certified-life-col visailabs-certified-life-center">
							<img src="/assets/visailabs/life3.jpeg" alt="Main Office" className="visailabs-certified-life-img visailabs-certified-life-img-large" />
						</div>
						<div className="visailabs-certified-life-col">
							<img src="/assets/visailabs/life4.jpeg" alt="Office 2" className="visailabs-certified-life-img" />
							<img src="/assets/visailabs/life5.jpeg" alt="Team 2" className="visailabs-certified-life-img" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
